export default "__VITE_ASSET__qFC6FKOm__"